import Backbone from 'backbone'
import template from './config-url.hbs'
import FormView from 'scoreboard/components/form-view'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import httpsValidator from 'scoreboard/components/validators/https-validator'
import i18n from 'scoreboard/components/i18n'
import $ from 'jquery'
import config from 'scoreboard/components/config'

/**
 * View for setting an embedded-content widget's URL
 */
const ConfigUrl = Backbone.View.extend({
	tagName: 'form',
	className: 'config-url',

	initialize(options = {}) {
		this.options = options

		this._markedFields = []
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			guard: false
		})
	},

	render() {
		this.$el.empty().append(template(this.context()))

		// setup input validation
		this._markedFields.push(new MarkedField({
			el: this.$('[name=url]'),
			validator: [requiredValidator, httpsValidator]
		}).render())

		var setting = config.validateEmbeddedUrls? 'dashboards.embeddedContent.bannerMessage': 'dashboards.embeddedContent.bannerMessageShort'
		const message = i18n.get(setting)
		this.$('.banner').append(message)

		this.formView.start()

		return this
	},

	context() {
		return {
			dialogTitle: this.options.dialogTitle,
			url: this.model.properties.get('url')
		}
	},

	submit() {
		let url = this.$('[name=url]').val()

		return $.ajax({
			method: 'get',
			url: 'api/embedded-content/validate?' + $.param({ url }),
			success: (data) => {
				this.model.properties.set('url', url)
				this.trigger('done')
			},
			error: response => {
				this.formView.errorMessage(response.responseJSON.message)
			}
		})
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this._markedFields.forEach(f => f.remove())
	}
})

export default ConfigUrl

ConfigUrl.__filename__ = 'dashboards/widgets/embedded-content/config-url.js'
